// extracted by mini-css-extract-plugin
export default {"badge":"ROPIX","badge__compact":"Y4KwN","badge__compact--dark":"dlnfq","badge__compact--yandex":"nzBPO","badge__compact--sharing":"Ydjwc","compact-parameters":"EHgBL"};